module.exports = __webpack_public_path__ + "static/media/9x9.2e872aad.png";